import ReactGA from 'react-ga';

export function productClickGA(id, name, brand='') {
  // console.log(`${name} was clicked!`);
  ReactGA.plugin.execute('ec', 'addProduct', {
    id,
    name,
    brand,
  });
  ReactGA.plugin.execute('ec', 'setAction', 'click');
}

export function productImpressionGA(id, name, brand='') {
  // console.log(`${name} was viewed!`);
  ReactGA.plugin.execute('ec', 'addImpression', {
    id,
    name,
    brand,
  });
}

export function productCheckoutGA(name, category, price, coupon) {
  // console.log(`${name} was checked out!`);
  ReactGA.plugin.execute('ec', 'addProduct', {
    name,
    category,
    price,
    coupon,
  });
  ReactGA.plugin.execute('ec', 'setAction', 'checkout');
}

// Need to add price in booking summary API?
export function productPurchaseGA(name, bookingId) {
  // console.log(`${name} was purchased!`);
  ReactGA.plugin.execute('ec', 'addProduct', {
    name,
    price: '100.00',
    quantity: 1,
  });
  ReactGA.plugin.execute('ec', 'setAction', 'purchase', {
    id: bookingId,

  });
}

export function promoClickGA(name) {
  // console.log(`${id} promo code was used!`);
  ReactGA.plugin.execute('ec', 'addPromo', {
    name,
  });
  ReactGA.plugin.execute('ec', 'setAction', 'promo_click');
}

